import React, {
  createElement,
  lazy,
  Suspense,
  useEffect,
  useState,
} from "react";
import OffCanvas from "../UI/OffCanvas";
import { useSelector } from "react-redux";

const MarketWatchScriptInfo = lazy(() => import("./MarketWatchScriptInfo"));
const MarketWatchKeyboardShortcut = lazy(() =>
  import("./MarketWatchKeyboardShortcut")
);

const MarketWatchCanvas = ({ dispatch, uiActions, useChat }) => {
  const { canvasOptions } = useSelector((state) => state.ui);
  const [isCanvas, setIsCanvas] = useState({
    isOpen: false,
    rowData: {},
    title: "",
    canvasBody: null,
  });

  useEffect(() => {
    if (canvasOptions.isOpen) {
      if (canvasOptions?.name === "info") {
        setIsCanvas({
          isOpen: true,
          rowData: canvasOptions?.rowData,
          title: "",
          canvasBody: MarketWatchScriptInfo,
        });
      } else if (canvasOptions?.name === "keyboardShortcut") {
        setIsCanvas({
          isOpen: true,
          rowData: canvasOptions?.rowData,
          title: canvasOptions?.modalTitle,
          canvasBody: MarketWatchKeyboardShortcut,
        });
      }
    }
  }, [canvasOptions?.isOpen, canvasOptions?.name]);

  const handleClose = () => {
    dispatch(uiActions.clearCanvasOption());
    setIsCanvas({
      isOpen: false,
      rowData: {},
      title: "",
      canvasBody: null,
    });
  };

  return (
    <OffCanvas
      handleClose={handleClose}
      show={isCanvas.isOpen}
      title={isCanvas.title}
    >
      <Suspense fallback={<p>Loading...</p>}>
        {isCanvas.canvasBody && (
          <>
            {createElement(isCanvas.canvasBody, {
              rowData: isCanvas.rowData,
              useChat: useChat,
            })}
          </>
        )}
      </Suspense>
    </OffCanvas>
  );
};

export default MarketWatchCanvas;
